import _ from "lodash";
import dateFormat from "dateformat";

interface ContinueEditingEntity {
  publishedBy?: {
    firstName?: string;
    lastName?: string;
  };
  lastPublished?: Date | string;
}

export const getContinueEditingTooltip = (
  entity: ContinueEditingEntity | null | undefined,
): string | undefined => {
  if (!entity) {
    return undefined;
  }

  const firstName = _.get(entity, "publishedBy.firstName", "");
  const lastName = _.get(entity, "publishedBy.lastName", "");
  const fullName = `${firstName} ${lastName}`.trim();
  const name = fullName.length > 30 ? `${fullName.slice(0, 30)}…` : fullName;
  const lastPublished = _.get(entity, "lastPublished");

  if (!name && !lastPublished) {
    return undefined;
  }

  if (lastPublished) {
    const publishedAt = new Date(lastPublished);
    const date = dateFormat(publishedAt, "d mmm yyyy");
    const time = dateFormat(publishedAt, "h:MM TT");

    if (name) {
      return `by ${name} on ${date} ${time}`;
    }

    return `on ${date} ${time}`;
  }

  return name ? `by ${name}` : undefined;
};
